export class RsyncConditionViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.syncId = data.syncId;
        this.targetOperation = data.targetOperation;
        this.identifyCode = data.identityCode;
        this.userCd = data.userCd;
        this.buknCd = data.buknCd;
        this.nyukyokeiyakuNo = data.nyukyokeiyakuNo;
        this.buknCd = data.buknCd;
    }
    model = null;
    syncId = null;
    targetOperation = null;
    identifyCode = "";
    userCd = null;
    buknCd = null;
    nyukyokeiyakuNo = null;
}
